export const reviewMocks = [
  {
    reviewName: "consist",
    reviewCon:
      "안녕하세요 저는 평소에 한국 시리즈를 구경하고 싶었는데, 이번 기회를 통해 직관 할 수 있어 너무 기쁩니다.",
    reviewProfile:
      "https://i.pinimg.com/736x/f8/48/fe/f848fee35e49c943842e6ef6cf6d7d26.jpg",
    reviewProfileAlt: "pinImg",
  },
  {
    reviewName: "consist",
    reviewCon:
      "안녕하세요 저는 평소에 한국 시리즈를 구경하고 싶었는데, 이번 기회를 통해 직관 할 수 있어 너무 기쁩니다.",
    reviewProfile:
      "https://i.pinimg.com/736x/f8/48/fe/f848fee35e49c943842e6ef6cf6d7d26.jpg",
    reviewProfileAlt: "pinImg",
  },
  {
    reviewName: "consist",
    reviewCon:
      "안녕하세요 저는 평소에 한국 시리즈를 구경하고 싶었는데, 이번 기회를 통해 직관 할 수 있어 너무 기쁩니다.",
    reviewProfile:
      "https://i.pinimg.com/736x/f8/48/fe/f848fee35e49c943842e6ef6cf6d7d26.jpg",
    reviewProfileAlt: "pinImg",
  },
  {
    reviewName: "consist",
    reviewCon:
      "안녕하세요 저는 평소에 한국 시리즈를 구경하고 싶었는데, 이번 기회를 통해 직관 할 수 있어 너무 기쁩니다.",
    reviewProfile:
      "https://i.pinimg.com/736x/f8/48/fe/f848fee35e49c943842e6ef6cf6d7d26.jpg",
    reviewProfileAlt: "pinImg",
  },
  {
    reviewName: "consist",
    reviewCon:
      "안녕하세요 저는 평소에 한국 시리즈를 구경하고 싶었는데, 이번 기회를 통해 직관 할 수 있어 너무 기쁩니다.",
    reviewProfile:
      "https://i.pinimg.com/736x/f8/48/fe/f848fee35e49c943842e6ef6cf6d7d26.jpg",
    reviewProfileAlt: "pinImg",
  },
  {
    reviewName: "consist",
    reviewCon:
      "안녕하세요 저는 평소에 한국 시리즈를 구경하고 싶었는데, 이번 기회를 통해 직관 할 수 있어 너무 기쁩니다.",
    reviewProfile:
      "https://i.pinimg.com/736x/f8/48/fe/f848fee35e49c943842e6ef6cf6d7d26.jpg",
    reviewProfileAlt: "pinImg",
  },
  {
    reviewName: "consist",
    reviewCon:
      "안녕하세요 저는 평소에 한국 시리즈를 구경하고 싶었는데, 이번 기회를 통해 직관 할 수 있어 너무 기쁩니다.",
    reviewProfile:
      "https://i.pinimg.com/736x/f8/48/fe/f848fee35e49c943842e6ef6cf6d7d26.jpg",
    reviewProfileAlt: "pinImg",
  },
  {
    reviewName: "consist",
    reviewCon:
      "안녕하세요 저는 평소에 한국 시리즈를 구경하고 싶었는데, 이번 기회를 통해 직관 할 수 있어 너무 기쁩니다.",
    reviewProfile:
      "https://i.pinimg.com/736x/f8/48/fe/f848fee35e49c943842e6ef6cf6d7d26.jpg",
    reviewProfileAlt: "pinImg",
  },
  {
    reviewName: "consist",
    reviewCon:
      "안녕하세요 저는 평소에 한국 시리즈를 구경하고 싶었는데, 이번 기회를 통해 직관 할 수 있어 너무 기쁩니다.",
    reviewProfile:
      "https://i.pinimg.com/736x/f8/48/fe/f848fee35e49c943842e6ef6cf6d7d26.jpg",
    reviewProfileAlt: "pinImg",
  },
  {
    reviewName: "consist",
    reviewCon:
      "안녕하세요 저는 평소에 한국 시리즈를 구경하고 싶었는데, 이번 기회를 통해 직관 할 수 있어 너무 기쁩니다.",
    reviewProfile:
      "https://i.pinimg.com/736x/f8/48/fe/f848fee35e49c943842e6ef6cf6d7d26.jpg",
    reviewProfileAlt: "pinImg",
  },
];
